import { TTransactionCardType } from './TransactionCard.types';

export const getImageSrc = (type: TTransactionCardType) => {
  switch (type) {
    case 'Decomposition':
      return 'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/transactions/Decomposition.svg';
    case 'Redemption':
      return 'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/transactions/Withdrawal.svg';
    case 'Issuance':
    default:
      return 'https://s3.ir-thr-at1.arvanstorage.com/mofidapp/transactions/Deposit.svg';
  }
};
